<template>
  <div :class="componentClassName">
    <a-page-heading>営業時間設定</a-page-heading>
    <m-section variant="fullpage">
      <m-action-card :title="`${numberName}（${telNumber}）の休日設定`" icon="calendar" :narrow-body="true">
        <form ref="form" class="t-setting-business-hours-edit-holiday__form" @submit.prevent="handleFormSubmit">
          <div class="t-setting-business-hours-edit-holiday__fields">
            <o-holiday-setting-list v-model="currentHolidayList" />
            <m-form-action-buttons>
              <a-button id="store" variant="block" color="primary" :disabled="savaButtonDisable" submit="submit">
                保存
              </a-button>
              <a-button id="cancel" variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button>
            </m-form-action-buttons>
          </div>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="settingHoursEditHoliday_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
      <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MSection from '@/components/molecules/section';
import OHolidaySettingList from '@/components/organisms/holiday-setting-list';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AButton from '@/components/atoms/button';
import { cloneDeep } from 'lodash';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { POINT } from '@/libs/constants';

// For Trial
import { utils } from '@/common/utils.js';

export default {
  name: 't-setting-business-hours-edit-holiday',
  components: {
    APageHeading,
    MActionCard,
    MSection,
    OHolidaySettingList,
    MFormActionButtons,
    AButton,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    holidayList: {
      type: Array,
      default: new Array(0),
    },
    companyID: {
      type: String,
      default: '',
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      currentHolidayList: [],
      selectedCompanyID: '',
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      savaButtonDisable: false,
      telNumber: '',
      numberName: '',
      saveSuccessFlag: false, // 保存成功フラグ
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-business-hours-edit-holiday');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    holidayList: {
      handler(val) {
        this.currentHolidayList = val;
      },
      deep: true,
    },
  },
  created() {
    if (this.$route.query.companyID) {
      this.selectedCompanyID = this.$route.query.companyID;
    } else {
      this.selectedCompanyID = this.companyID;
    }
    this.telNumber = this.$route.params.telNumber;
    this.numberName = this.$route.params.numberName;
    if (!this.telNumber || !this.numberName) {
      this.$router.push({ name: 'ServiceConditionList' });
      return;
    }
    this.handlerGetHolidayList();
  },
  mounted() {
    this.currentHolidayList = this.holidayList;
    if (utils.chkTrialCompanyID(this.companyID) || utils.chkTrialCompanyID(this.selectedCompanyID)) {
      this.savaButtonDisable = true;
      this.showInfoModal(messageContent.notifyTrialUserCanNotSaveBusinessHours('休日設定'));
    }
  },
  methods: {
    handlerGetHolidayList: function () {
      this.postRequest('/servicecondition/getholiday', { companyID: this.selectedCompanyID, telNumber: this.telNumber })
        .then(e => {
          this.currentHolidayList = e.currentHolidayList;
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('休日設定の取得'));
        });
    },
    handleFormSubmit(e) {
      e.preventDefault();
      const payload = cloneDeep(this.currentHolidayList);
      this.handleSaveClick(payload);
    },
    handleSaveClick() {
      if (this.currentHolidayList.length > 30) {
        this.showErrorModal(messageContent.exceedMaxHolidays);
        return;
      }
      const formDataTmp = {
        companyID: this.selectedCompanyID,
        telNumber: this.telNumber,
        currentHolidayList: this.currentHolidayList,
      };
      this.setLoading(true);
      this.postRequest('/servicecondition/updateholiday', formDataTmp)
        .then(e => {
          if (e.status === 'success') {
            this.showUpdateInfoModal(messageContent.holidaysSettingCompleted);
          } else if (e.status === 'duplicate') {
            this.showErrorModal(e.message);
          } else {
            this.showErrorModal(messageContent.updateSettingError);
          }
          this.setLoading(false);
        })
        .catch(e => {
          if (e === 404) return this.showErrorModal(messageContent.noOperationPermission);
          this.setLoading(false);
          return this.showErrorModal(messageContent.updateSettingError);
        });
    },
    handleCancelClick() {
      if (this.companyID === POINT) {
        this.$router.push({
          path: '/service-condition',
          query: { companyID: this.$route.query.companyID, telNumber: this.telNumber },
        });
      } else {
        this.$router.push({ path: '/service-condition', query: { telNumber: this.telNumber } });
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (this.saveSuccessFlag) {
        // 正常保存の場合、営業時間設定画面に遷移
        this.handleCancelClick();
      }
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = false;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = false;
    },
    showUpdateInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = true;
    },
  },
};
</script>
